import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { logApiConfig } from './utils/apiConfig';
import { applyBranding } from './utils/branding';


// Log the API configuration for debugging
logApiConfig();

// Swap logos/favicon on white-labeled domains (e.g. colabor8.stellair.ai)
applyBranding();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
